/**
 * The point that is passed to the tooltip component.
 */
var TooltipPoint = /** @class */ (function () {
    /**
     * @hidden
     */
    function TooltipPoint(point, format) {
        this.value = point.value;
        this.category = point.category;
        this.categoryIndex = point.categoryIx;
        this.series = point.series;
        this.dataItem = point.dataItem;
        this.percentage = point.percentage;
        this.runningTotal = point.runningTotal;
        this.total = point.total;
        this.low = point.low;
        this.high = point.high;
        this.xLow = point.xLow;
        this.xHigh = point.xHigh;
        this.yLow = point.yLow;
        this.yHigh = point.yHigh;
        this.point = point;
        this.format = ((point.options || {}).tooltip || {}).format || format;
    }
    Object.defineProperty(TooltipPoint.prototype, "formattedValue", {
        get: function () {
            return this.format ? this.point.formatValue(this.format) : String(this.value);
        },
        enumerable: true,
        configurable: true
    });
    return TooltipPoint;
}());
export { TooltipPoint };
//# sourceMappingURL=Point.js.map